import BaseApi from '../../../infraestructure/BaseApi';

export default class ApiPermissions extends BaseApi{
    constructor(client, endPoint) {
        super(client, endPoint)
    }
}